import { Helmet } from "react-helmet-async";
import { useParams, Link } from "react-router-dom";

function PortfolioDetails() {
  const { id } = useParams();

  const projects = {
    1: {
      title: "Event Management Platform",
      category: "Empower",
      type: "Web Application",
      description: "A comprehensive platform designed to streamline event planning, management, and execution. This solution empowers organizations to create, manage, and track events with ease.",
      challenge: "The client needed a unified system to manage multiple events simultaneously while maintaining efficiency and user satisfaction.",
      solution: "We developed a scalable platform with real-time updates, automated notifications, and comprehensive analytics to help event managers stay on top of every detail.",
      results: [
        "50% reduction in event planning time",
        "30% increase in attendee satisfaction",
        "Streamlined workflow for event teams"
      ],
      technologies: ["React", "Node.js", "MongoDB", "AWS"]
    },
    2: {
      title: "Digital Marketing Campaign",
      category: "Support",
      type: "Marketing Strategy",
      description: "A data-driven digital marketing campaign that increased brand awareness and customer engagement across multiple channels.",
      challenge: "Low brand visibility and declining customer engagement in a competitive market.",
      solution: "We created a multi-channel marketing strategy with targeted content, social media campaigns, and performance analytics.",
      results: [
        "200% increase in brand awareness",
        "150% growth in lead generation",
        "Improved ROI on marketing spend"
      ],
      technologies: ["SEO", "Social Media", "Content Marketing", "Analytics"]
    }
  };

  const project = projects[id] || projects[1];

  return (
    <>
      <Helmet><title>{project.title} - Portfolio - Bexon</title></Helmet>
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-indigo-900 via-purple-900 to-indigo-800 text-white py-20">
        <div className="container mx-auto px-4">
          <Link to="/portfolio" className="text-yellow-400 hover:text-yellow-300 mb-4 inline-block">
            ← Back to Portfolio
          </Link>
          <div className="text-yellow-400 font-semibold mb-2">{project.category}</div>
          <h1 className="text-5xl font-bold mb-4">{project.title}</h1>
          <p className="text-xl text-gray-300">{project.type}</p>
        </div>
      </section>

      {/* Overview Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Project Overview</h2>
            <p className="text-lg text-gray-700 mb-12">{project.description}</p>

            <div className="grid md:grid-cols-2 gap-12 mb-12">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">The Challenge</h3>
                <p className="text-gray-700">{project.challenge}</p>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Solution</h3>
                <p className="text-gray-700">{project.solution}</p>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Key Results</h3>
              <ul className="space-y-4">
                {project.results.map((result, idx) => (
                  <li key={idx} className="flex items-start">
                    <span className="text-green-600 mr-3 text-xl">✓</span>
                    <span className="text-gray-700 text-lg">{result}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Technologies Used</h2>
            <div className="flex flex-wrap justify-center gap-4">
              {project.technologies.map((tech, idx) => (
                <span
                  key={idx}
                  className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-semibold"
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-indigo-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Start Your Project?</h2>
          <p className="text-xl text-gray-200 mb-8">Let's discuss how we can help bring your vision to life.</p>
          <Link to="/contact" className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-semibold px-8 py-3 rounded-lg transition inline-block">
            Get in Touch
          </Link>
        </div>
      </section>
    </>
  );
}

export default PortfolioDetails;

